/*=========================================================================================
  File Name: module-usertax-mutations.js
  Description: UserTax Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
/**
 * state mặc định của module
 */

import defaultState from './module-auditinglog-state';

export default {
	resetState(state) {
		Object.assign(state, defaultState);
	},
	updateAuditingLogs(state, res) {
		state.AuditingLogs = res.Data || [];
		state.AuditingLogTotal = res.Total;
	}
};
